import { VEC_ICON_NAME } from "../../../../../../components/icons/constants";

export const CHOOSE_METHOD_CARD_NAMES = {
    CREATE_ONE: "CREATE_ONE",
    BULK_UPLOAD: "BULK_UPLOAD",
    INTEGRATION: "INTEGRATION"
}

export const CHOOSE_METHOD_CARDS = [
    { name: CHOOSE_METHOD_CARD_NAMES.CREATE_ONE, title: "Add one at a time", icon: VEC_ICON_NAME.UPLOAD_FROM_COMPUTER, subText: "We will guide you to add payers step by step", linkButtonText: "" },

    { name: CHOOSE_METHOD_CARD_NAMES.BULK_UPLOAD, title: "Upload bulk excel", icon: VEC_ICON_NAME.UPLOAD_FROM_COMPUTER, subText: "Use our easy to use template to quickly add multiple payers", linkButtonText: "Download our template" },

    { name: CHOOSE_METHOD_CARD_NAMES.INTEGRATION, title: "Integration", icon: VEC_ICON_NAME.UPLOAD_FROM_COMPUTER, subText: "Full set of integrations and import features.", linkButtonText: "" },

    // { title: "Link your accounting softwares", icon: VEC_ICON_NAME.UPLOAD_FROM_COMPUTER, subText: "We will help you integrate all your accounting data instantly", linkButtonText: "Which softwares can I use?" },

    // { title: "Import using API services", icon: VEC_ICON_NAME.UPLOAD_FROM_COMPUTER, subText: "We can import your data from our API services seamlessly", linkButtonText: "API Documentation" }
];

export const CHOOSE_METHOD_CARDS_RECIPIENT = [
    { name: CHOOSE_METHOD_CARD_NAMES.CREATE_ONE, title: "Add one at a time", icon: VEC_ICON_NAME.UPLOAD_FROM_COMPUTER, subText: "We will guide you to add recipients step by step", linkButtonText: "" },

    { name: CHOOSE_METHOD_CARD_NAMES.BULK_UPLOAD, title: "Upload bulk excel", icon: VEC_ICON_NAME.UPLOAD_FROM_COMPUTER, subText: "Use our easy to use template to quickly add multiple recipients", linkButtonText: "Download our template" },
]